import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  HeadingText,
  BodyText,
  CaptionText,
  Avatar,
} from '@paypalcorp/pp-react';
import { CharitiesIcon, FundraiserIcon } from '@paypalcorp/pp-react-icons';
import GivingSummaryAction from '../givingSummaryAction/givingSummaryAction';
import styles from './givingSummarySection.less';
import * as analytics from '../../lib/analytics';

const GivingSummarySection = ({
  type,
  amount = {},
  stats = [],
  suggestedActions = [],
  defaultFPTITags,
  isLoading = false,
}) => {
  const hasActions = suggestedActions.length > 0;

  const statItems = stats.map((stat, index) => (
    <div key={index} className={styles.stat}>
      <CaptionText>{stat.label}</CaptionText>
      <HeadingText size='sm' isLoading={isLoading}>
        {stat.value}
      </HeadingText>
    </div>
  ));

  const actionItems = suggestedActions.map((action, index) => (
    <GivingSummaryAction
      key={index}
      action={action}
      defaultFPTITags={defaultFPTITags}
    />
  ));

  const donateAvatar = (
    <Avatar
      className={styles.avatar}
      svgIconComponent={CharitiesIcon}
      color='sysColorAccent2Main'
      size='md'
    />
  );

  const fundraiserAvatar = (
    <Avatar
      className={styles.avatar}
      svgIconComponent={FundraiserIcon}
      color='sysColorAccent1Main'
      size='md'
    />
  );

  useEffect(() => {
    if (type === 'donated') {
      analytics.instance.recordEvent(
        analytics.events.DW_GIVING_IMPACT_SUMMARY_CHARITY_SHOWN,
        {
          ...defaultFPTITags,
          e: 'im',
        }
      );
    } else {
      analytics.instance.recordEvent(
        analytics.events.DW_GIVING_IMPACT_SUMMARY_FUNDRAISER_SHOWN,
        {
          ...defaultFPTITags,
          e: 'im',
        }
      );
    }
  }, []);

  return (
    <div className={styles.summary}>
      <div className={styles.amount}>
        {type === 'donated' ? donateAvatar : fundraiserAvatar}
        <div className={styles.header}>
          <BodyText>{amount.label}</BodyText>
          <HeadingText isLoading={isLoading}>{amount.value}</HeadingText>
        </div>
      </div>
      <div className={styles.statsContainer}>
        <div className={styles.statsGroup}>{statItems}</div>
      </div>
      {hasActions && <div className={styles.actionsGroup}>{actionItems}</div>}
    </div>
  );
};

GivingSummarySection.propTypes = {
  type: PropTypes.string,
  amount: PropTypes.object,
  stats: PropTypes.array,
  suggestedActions: PropTypes.array,
  defaultFPTITags: PropTypes.object,
  isLoading: PropTypes.bool,
};

export default GivingSummarySection;
